const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTfgFaviconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1167 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.398293,0,0,0.852273,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2929.17,
    height: 1466.67,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    transform: "matrix(10.4613,0,0,4.88889,-2485.34,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,377.109,79.5568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-33.736C46.998,-33.736 87.65,-15.419 107.26,11.225C94.977,-21.085 51.611,-44.961 0,-44.961C-51.612,-44.961 -94.977,-21.085 -107.261,11.225C-87.651,-15.419 -46.999,-33.736 0,-33.736",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,284.98,238.034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-97.6L-21.537,-97.6L-21.537,-122.753L50.086,-122.753L50.086,-97.6L28.406,-97.6L28.406,25.153L0,25.153L0,-97.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,345.138,263.187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-147.906L61.348,-147.906L61.348,-122.753L28.484,-122.753L28.484,-89.049L59.485,-89.049L59.485,-63.895L28.484,-63.895L28.484,0L0,0L0,-147.906Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,491.706,115.281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,147.906L-21.385,147.906C-22.05,145.324 -22.493,140.058 -22.715,136.956C-27.394,147.343 -36.894,150.123 -46.035,150.123C-69.057,150.123 -75.526,132.996 -75.526,108.83L-75.526,39.238C-75.526,16.557 -66.14,-2.217 -37.919,-2.217C-3.857,-2.217 -0.431,22.566 -0.431,37.482L-0.431,44.137L-29.07,44.137L-29.07,35.996C-29.07,28.825 -29.945,22.182 -37.841,22.182C-44.354,22.182 -46.756,26.945 -46.756,36.583L-46.756,112.4C-46.756,122.47 -43.509,126.155 -37.841,126.155C-30.921,126.155 -28.561,120.775 -28.561,108.613L-28.561,87.401L-38.351,87.401L-38.351,63.398L0,63.398L0,147.906Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfgFaviconWhite);
export default __webpack_public_path__ + "static/media/tfg_favicon_white.0f2d90ddee91f6884cb5de9a9816d432.svg";
export { ForwardRef as ReactComponent };